module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAQAAABKfvVzAAAAHUlEQVQ4y2NgGAU0BP+BEEbjgpRpGPXDSPHDiAIA9Z5focw337kAAAAASUVORK5CYII="